/**
 * Created by idea on 06/04/2017.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { Location } from "@angular/common";
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private location: Location) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url = next.routeConfig.path;
    // let isShop = localStorage.getItem('isShop');
    var timestamp = Math.round(Date.now() / 1000);
    // var arrayIsShop = ['product','product/add','order/shop','order_free','customers_shop','vendors','brands','shipping','bill_info','history/warehouse','history/payment','dashboard','income_shop', 'sprofile'];

    if (!this.isAuthenticated()) {
      localStorage.clear();
      sessionStorage.clear();
      // this.location.path("http://bussiness-center.dev.icheck.vn/")
      // window.location.href = "http://bussiness-center.dev.icheck.vn/";
      this.router.navigate(["/login"]);
      return false;
    }

    if (localStorage.getItem('Access-Token') && localStorage.getItem('Access-Token-Icheck')) {
      // if(isShop == 'false'){
      //     if( arrayIsShop.indexOf(url) >= 0){
      //         this.router.navigate(['/permission/error']);
      //         return false;
      //     }
      // }
      return true;
    }
    // this.location.path("http://bussiness-center.dev.icheck.vn/")
    // window.location.href = "http://bussiness-center.dev.icheck.vn/";

    this.router.navigate(["/login"]);
    return false;
  }

  isAuthenticated() {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return Date.now() + 60000 < expiresAt;
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/Auth.guard.ts